type OutlinedBoxProps = React.HTMLAttributes<HTMLDivElement>

const OutlinedBox = (props: OutlinedBoxProps) => {
    const { className, ...others } = props
    return (
        <div className={`bg-background border rounded-sm ${className}`} {...others}>
            {props.children}
        </div>
    )
}

export default OutlinedBox
